module.exports = __webpack_public_path__ + "fonts/f35ee58.woff";